import React from 'react';
import partners from '../data/partnersData';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const Partners = ({ title = 'Our Partners' }) => {
  return (
    <section className="container mx-auto px-4 py-16" id="partners">
      <div className="text-center mb-8">
        <p className="text-green-600 text-xl font-semibold">{title}</p>
      </div>

      <div>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          slidesPerView={1}
          spaceBetween={20}
          loop={true}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            640: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            1024: { slidesPerView: 4 },
          }}
        >
          {partners.map((p) => (
            <SwiperSlide key={p.id} className="flex items-center justify-center">
              <a href={p.website} target="_blank" rel="noreferrer" className="flex flex-col items-center bg-white p-4 rounded hover:shadow-md transition w-full max-w-xs mx-auto">
                <img src={p.logo} alt={p.name} className="h-20 object-contain mb-2" />
                <div className="text-center">
                  <h4 className="font-medium">{p.name}</h4>
                </div>
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default Partners;
